module.exports = __webpack_public_path__ + "static/img/story_video.f94db56.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/story_video.png
// module id = rg+0
// module chunks = 1